import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import { getScrollElementId } from 'redux-app/selectors/pageScroller'

export const withScrollToElements = (pageScrollers = []) => BaseComponent => compose(
  connect(
    state => ({
      scrollElementId: getScrollElementId(state),
    }),
    {
      setScrollElementId,
    },
  ),
  lifecycle({
    componentDidMount () {
      const { scrollElementId, setScrollElementId } = this.props
      if (scrollElementId !== null) {
        const pageScroller = pageScrollers.find(pageScroller => {
          return pageScroller.getElementId() === scrollElementId
        })
        if (pageScroller) {
          pageScroller.goToElement()
          setScrollElementId(null)
        }
      }
    },
    componentWillReceiveProps (nextProps) {
      if (this.props.scrollElementId !== nextProps.scrollElementId && nextProps.scrollElementId !== null) {
        const pageScroller = pageScrollers.find(pageScroller => {
          return pageScroller.getElementId() === nextProps.scrollElementId
        })
        if (pageScroller) {
          pageScroller.scrollToElement()
          nextProps.setScrollElementId(null)
        }
      }
    },
  }),
)(BaseComponent)
